<template>
  <div>
    <!--点击关联货物 2.0-->
    <div class="guanLianBox">
      <el-dialog :title="title" :visible.sync="guanlianVisible" :close-on-click-modal="false" width="90%" center
        @close="additiveQuXiao">
        <div>
          <div class="detailsTitles">
            <h4>货物信息</h4>
            <span v-if="GuanlianHuowuRow.cargoControlFalg == 1" style="margin-left:10px;">控货剩余量：<span
                style="color:red;">{{ KhShengyu }}</span> 吨</span>
            <span v-if="GuanlianHuowuRow.cargoControlFalg == 1" style="margin-left:10px;">计划量合计:<span
                style="color:red;">{{ Jhliang }}</span> 吨</span>
          </div>
          <el-table border bordersize="mini" :data="copyTableList" style="width: 100%">
            <el-table-column :show-overflow-tooltip="true" prop="productTypeName" align="center" label="货物类型">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="steelMillName" align="center" label="产地">
            </el-table-column>
            <el-table-column prop="model" align="center" label="材质"></el-table-column>
            <el-table-column prop="specification" align="center" label="规格"></el-table-column>
            <!-- <el-table-column prop="length" align="center" label="长度（m）"></el-table-column> -->
            <el-table-column prop="warehouseName" align="center" label="仓位"></el-table-column>
            <el-table-column prop="locationName" align="center" label="区位"></el-table-column>
            <el-table-column prop="stockAvailableNumber" align="center" label="仓库可提件数"></el-table-column>
            <el-table-column prop="customerAvailableNumber" align="center" label="客户可提件数"></el-table-column>
            <el-table-column prop="number" align="center" label="件数"></el-table-column>
            <el-table-column prop="allWeight" align="center" label="重量（吨）"></el-table-column>
            <el-table-column label="编辑" width="180">
              <template slot-scope="scope3">
                <el-button @click="delClickCopy(scope3.$index, scope3.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="margin-left:15px;margin-top:15px;;">
          <el-button type="primary" @click="addHuoWuBtn">新增</el-button>
          <!-- <el-button type="primary" @click="additiveOk">确定</el-button>
            <el-button type="primary" @click="additiveQuXiao">取消</el-button>-->
        </div>
        <el-table size="mini" :data="detailsDataCopyAdd" ref="demoTable" border bordersize="mini"
          style="width:100%;margin-top:20px;" :header-cell-style="{ background: '#f5f5f5' }" empty-text="请点击上方添加按钮添加货物">
          <el-table-column prop="productType" align="center" label="货物类型">
            <template slot-scope="scope1">
              <el-select v-model="scope1.row.productType" size="mini" clearable placeholder="请选择"
                @change="selectProductType">
                <el-option v-for="(item, index) in productTypeOptions" :key="index" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="steelMillName" align="center" label="产地">
            <template slot-scope="scope1">
              <el-select filterable clearable v-model="scope1.row.steelMillName"
                @change="changeChanDi(scope1.row, scope1.row.steelMillName)" size="mini" placeholder="请选择产地"
                :disabled="disChandi">
                <el-option v-for="(item, index) in chanDiOptions" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="specification" align="center" label="规格">
            <template slot-scope="scope1">
              <el-select filterable clearable @change="changeGuiGe(scope1.row, scope1.row.specification)"
                v-model="scope1.row.specification" size="mini" :disabled="disGuige" placeholder="请选择规格">
                <el-option v-for="(item, index) in guigeOptions" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="model" align="center" label="材质">
            <template slot-scope="scope1">
              <el-select filterable clearable @change="changeCaiZhi(scope1.row, scope1.row.model)"
                v-model="scope1.row.model" size="mini" :disabled="disCaiZhi" placeholder="请选择材质">
                <el-option v-for="(item, index) in caizhiOptions" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <!-- <el-table-column v-if="HwType" prop="length" align="center" label="长度（m）">
              <template slot-scope="scope1">
                <el-select
                  filterable
                  clearable
                  @change="changeChangDu(scope1.row,scope1.row.length)"
                  v-model="scope1.row.length"
                  size="mini"
                  :disabled="disChangDu"
                  placeholder="请选择长度"
                >
                  <el-option
                    v-for="(item,index) in changDuOptions"
                    :key="index"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column> -->
          <el-table-column prop="warehouseId" align="center" label="仓位">
            <template slot-scope="scope1">
              <el-select filterable clearable @change="changeCangWei(scope1.row, scope1.row.warehouseId)"
                v-model="scope1.row.warehouseId" :disabled="disCangwei" size="mini" placeholder="请选择仓位">
                <el-option v-for="(item, index) in CangweiOptions" :key="index" :label="item.value" :value="item.id">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="locationId" align="center" label="区位">
            <template slot-scope="scope1">
              <el-select filterable clearable @change="changeQuWei(scope1.row, scope1.row.locationId)"
                v-model="scope1.row.locationId" :disabled="disQuwei" size="mini" placeholder="请选择区位">
                <el-option v-for="(item, index) in QuweiOptions" :key="index" :label="item.value" :value="item.id">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="allNumber" align="center" label="库存件数">
            <template slot-scope="scope1">
              <el-input :disabled="true" v-model="scope1.row.allNumber" maxlength="50" placeholder="请输入库存件数"
                size="mini"></el-input>
            </template>
          </el-table-column> -->
          <el-table-column prop="stockAvailableNumber" align="center" label="仓位可提件数">
            <template slot-scope="scope1">
              <el-input :disabled="true" v-model="scope1.row.stockAvailableNumber" maxlength="50" placeholder="请输入仓位可提件数"
                size="mini"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="customerAvailableNumber" align="center" label="客户可提件数">
            <template slot-scope="scope1">
              <el-input :disabled="true" v-model="scope1.row.customerAvailableNumber" maxlength="50"
                placeholder="请输入客户可提件数" size="mini"></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="number" align="center" label="可计划件数">
              <template slot-scope="scope1">
                <el-input
                  :disabled="true"
                  v-model="scope1.row.number"
                  maxlength="50"
                  placeholder="请输入件数"
                  size="mini"
                ></el-input>
              </template>
            </el-table-column> -->
          <el-table-column prop="number" align="center" label="件数">
            <template slot-scope="scope1">
              <el-input onkeyup="value=value.replace(/[^\d]/g,'')" @change="changeJianShu(scope1.row, scope1.row.number)"
                :disabled="disJianShu" v-model="scope1.row.number" v-number-input.float="0" maxlength="50"
                placeholder="请输入件数" size="mini"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="weight" align="center" label="重量（吨）">
            <template slot-scope="scope1">
              <!-- <el-input
                  v-model="scope1.row.weight"
                  maxlength="50"
                  placeholder="请输入重量"
                  size="mini"
                  :disabled="scope1.row.disWeight"
                  @blur="NumberInputWeight(scope.row)"
                ></el-input> -->
              <el-input v-show="scope1.row.disWeight" v-model="scope1.row.weight" v-number-input.float="3" type="text"
                @blur="NumberInputWeight(scope1.row)" size="mini" :disabled='scope1.row.disWeight'></el-input>
              <el-input v-show="!scope1.row.disWeight" v-model="scope1.row.allWeight" v-number-input.float="3" type="text"
                @blur="NumberInputWeight(scope1.row)" size="mini" :disabled='scope1.row.disWeight'>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop align="center" label="编辑">
            <template slot-scope="scope2">
              <el-button @click="delClick(scope2.$index, scope2.row)" type="text" size="small">删除</el-button>
              <el-button @click="addOkClick(scope2.$index, scope2.row)" type="text" size="small">保存</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="color:red;margin-top:8px;">注：默认重量（吨）= 单件理重（吨）* 件数</div>
        <div style="margin:15px auto;" class="el-dialog--center">
          <el-button @click="additiveQuXiao">取消</el-button>
          <el-button type="primary" @click="additiveOk()">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import DonMessage from '@/utils/message'

import {
  getLwgTStockSummaryGroup,
  addTOutstockSummaryZy
} from '@/api/wms-access'
import {
  getWeighingMethodList,
  surplusControlWeight,
  getNumberForBillStockWarehouse,
  getEmptyBillStockWarehouseInfo,
  getEmptyBillStockLocationInfo,
  getCusAvNuExp,
  getTEmptyStockCustomerGroupExp
} from '@/api/wms-stock'
import {
  sortArr
} from '@/utils/util'

export default {
  name: 'GuanLianHuoWu',
  data() {
    return {
      title: '关联货物',
      guanlianVisible: false,
      copyTableList: [],
      detailsDataCopyAdd: [], // 添加货物数据
      productTypeOptions: [],

      // 产地选择框
      chanDiValue: '',
      chanDiOptions: [],
      disChandi: true,
      // 材质
      caiZhiValue: '',
      caizhiOptions: [],
      disCaiZhi: true,
      // 规格选择框
      guiGeValue: '',
      guigeOptions: [],
      disGuige: true,
      // 仓位
      warehouseId: '',
      CangweiOptions: [],
      QuweiOptions: [],
      disCangwei: true,
      disQuwei: true,

      // 长度选择框
      // changDuValue: '',
      // changDuOptions: [],
      // disChangDu: true,
      // 件数
      jianShuValue: '',
      allNumber: '',
      disJianShu: true,
      disDanHao: true,
      // 单件理重
      singletonWeight: 0,
      huowuInfos: {
        primaryCustomerTaxId: '',
        customerTaxId: '',
        productType: '',
        steelMillName: '',
        model: '',
        specification: '',
        // length: '',
        warehouseId: '',
        steelMillName: '',
        ownerCustomerTaxId: ''
      },
      HwType: true,
      KhShengyu: 0,
      Jhliang: 0,
      primaryCustomerTaxId: '',
      customerTaxId: '',
      outWeighingMethod: '',
      ownerCustomerTaxId: ''
    }
  },
  props: {
    addProductTypeTwoMark: {
      type: Boolean,
      default: false
    },
    // HwType: {
    //   type: Boolean,
    //   default: false
    // },
    GuanlianHuowuRow: {
      type: Object
    }
  },
  watch: {
    addProductTypeTwoMark: {
      immediate: true,
      deep: true,
      handler(val) {
        this.guanlianVisible = val
      }
    },
    // HwType: {
    //   immediate: true,
    //   deep: true,
    //   handler (val) {
    //     if (val) this.title += '(螺纹钢)'
    //     else this.title += '(盘螺、高线)'
    //   }
    // },
    GuanlianHuowuRow: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.huowuInfos.primaryCustomerTaxId = val.primaryCustomerTaxId
          this.huowuInfos.customerTaxId = val.customerTaxId
          this.huowuInfos.ownerCustomerTaxId = val.ownerCustomerTaxId
          this.primaryCustomerTaxId = val.primaryCustomerTaxId
          this.customerTaxId = val.customerTaxId
          this.ownerCustomerTaxId = val.ownerCustomerTaxId
          // console.log(this.huowuInfos.ownerCustomerTaxId, 'this.huowuInfos.ownerCustomerTaxId')
          this.getTEmptyStockCustomerGroupExps()

          // this.getLwgTStockSummaryGroups()
          // if (val.productType == '4' || val.productType == '7') {
          //   this.getLwgTStockSummaryGroups()
          //   // this.title = '关联货物(螺纹钢)'
          //   this.HwType = true
          // } else if (val.productType == '5' || val.productType == '6') {
          //   this.getTEmptyStockCustomerGroupExps()
          //   // this.title = '关联货物(盘螺、高线)'
          //   this.HwType = false
          // }
        }
      }
    }
  },
  created() {
    // this.getPlaceOfOriginListS()
    this.addProductTypeClick(this.GuanlianHuowuRow)
    if (this.GuanlianHuowuRow.cargoControlFalg == '1') this.surplusControlWeights()
  },
  methods: {
    selectProductType() {
      // if (this.hwFormData.productType == '4' || this.hwFormData.productType == '7') {
      //   // this.xzTitle = '添加货物(螺纹钢)'
      //   this.showLwg = true
      // } else if (this.hwFormData.productType == '5' || this.hwFormData.productType == '6') {
      //   // this.xzTitle = '添加货物(盘螺、高线)'
      //   this.showLwg = false
      // }
      this.disChandi = false
      this.disGuige = true
      this.disCaizhi = true
      this.dislength = true
      this.disDanzhi = true
      this.disCangwei = true
      this.disQuwei = true
      this.huowuInfos.productType = this.detailsDataCopyAdd[0].productType
      // this.detailsDataCopyAdd[0].productTypeName = this.productTypeOptions.filter(item => item.id == this.detailsDataCopyAdd[0].productType)[0].name

      this.huowuInfos.steelMillName = ''
      this.huowuInfos.steelMillName = ''
      this.huowuInfos.specification = ''
      this.huowuInfos.model = ''
      this.huowuInfos.warehouseId = ''
      this.huowuInfos.stockWarehouseId = ''

      this.detailsDataCopyAdd[0].steelMillName = ''
      this.detailsDataCopyAdd[0].model = ''
      this.detailsDataCopyAdd[0].specification = ''
      this.detailsDataCopyAdd[0].warehouseId = ''
      this.detailsDataCopyAdd[0].locationId = ''
      this.detailsDataCopyAdd[0].allNumber = ''
      this.detailsDataCopyAdd[0].number = ''
      this.detailsDataCopyAdd[0].weight = ''
      this.detailsDataCopyAdd[0].stockAvailableNumber = ''
      if (this.detailsDataCopyAdd[0].productType != '') {
        this.detailsDataCopyAdd[0].productTypeName = this
          .productTypeOptions.filter(item => item.id == this.detailsDataCopyAdd[0].productType)[0].name
      }

      this.HwType = false
      this.disCaiZhi = true
      getTEmptyStockCustomerGroupExp(
        this.huowuInfos
      )
        .then(res => {
          this.chanDiOptions = Array.from(new Set(res.map(item => item.steelMillName)))
        })
        .catch(err => {
          DonMessage.error(err)
        })
      getWeighingMethodList({
        productType: this.detailsDataCopyAdd[0].productType
      }).then(res => {
        if (res[0].outWeighingMethod == 1) {
          this.detailsDataCopyAdd[0].disWeight = true
          this.outWeighingMethod = res[0].outWeighingMethod
        } else {
          this.detailsDataCopyAdd[0].disWeight = false
          this.outWeighingMethod = res[0].outWeighingMethod
        }
      })
    },
    changeChanDi(val, row) {
      console.log(val, row)
      // this.disCaiZhi = false
      this.disGuige = false

      this.huowuInfos.steelMillName = row
      this.huowuInfos.steelMillName = row
      this.huowuInfos.model = ''
      this.huowuInfos.specification = ''
      this.huowuInfos.warehouseId = ''
      this.huowuInfos.stockWarehouseId = ''

      this.detailsDataCopyAdd[0].model = ''
      this.detailsDataCopyAdd[0].specification = ''
      this.detailsDataCopyAdd[0].warehouseId = ''
      this.detailsDataCopyAdd[0].locationId = ''
      this.detailsDataCopyAdd[0].allNumber = ''
      this.detailsDataCopyAdd[0].number = ''
      this.detailsDataCopyAdd[0].weight = ''
      this.detailsDataCopyAdd[0].stockAvailableNumber = ''

      this.disCaiZhi = true
      this.disCangwei = true
      this.disQuwei = true
      // this.getLwgTStockSummaryGroups()
      // if (this.detailsDataCopyAdd[0].productType == '4' || this.detailsDataCopyAdd[0].productType == '7') {
      //   this.disChangDu = true

      //   this.detailsDataCopyAdd[0].length = ''
      //   getLwgTStockSummaryGroup(
      //     this.huowuInfos
      //   )
      //     .then(res => {
      //       this.caizhiOptions = Array.from(new Set(res.map(item => item.model)))
      //     })
      //     .catch(err => {
      //       DonMessage.error(err)
      //     })
      // } else {
      getTEmptyStockCustomerGroupExp(
        this.huowuInfos
      )
        .then(res => {
          this.guigeOptions = Array.from(new Set(res.map(item => item.specification)))
        })
        .catch(err => {
          DonMessage.error(err)
        })
      // }
    },
    changeCaiZhi(val, row) {
      console.log(val, row)
      this.disCangwei = false
      this.huowuInfos.model = val.model
      // this.huowuInfos.specification = ''
      this.huowuInfos.warehouseId = ''
      this.huowuInfos.stockWarehouseId = ''

      // this.detailsDataCopyAdd[0].specification = ''
      this.detailsDataCopyAdd[0].warehouseId = ''
      this.detailsDataCopyAdd[0].locationId = ''
      this.detailsDataCopyAdd[0].allNumber = ''
      this.detailsDataCopyAdd[0].number = ''
      this.detailsDataCopyAdd[0].weight = ''
      this.detailsDataCopyAdd[0].stockAvailableNumber = ''

      getEmptyBillStockWarehouseInfo(
        this.huowuInfos
      )
        .then(res => {
          let wareHouses = []
          res.tEmptyStockWarehouseList.forEach(item => {
            let objVal = {}
            objVal.id = item.warehouseId
            objVal.value = item.warehouseName
            objVal.stockWarehouseId = item.stockWarehouseId
            wareHouses.push(objVal)
          })
          console.log(wareHouses, 'wareHouses')

          if (this.huowuInfos.warehouseId == '') this.CangweiOptions = Array.from(new Set(wareHouses))
          // this.detailsDataCopyAdd[0].stockWarehouseId = res.tEmptyStockWarehouseList[0].stockWarehouseId
          console.log(this.CangweiOptions, 'this.CangweiOptions')
          const uniqueArr = [];

          this.CangweiOptions.forEach(item => {
            if (!uniqueArr.some(i => i.id === item.id)) {
              uniqueArr.push(item);
            }
          })
          console.log(uniqueArr, 'uniqueArr')
          this.CangweiOptions = uniqueArr
          this.singletonWeight = res.tEmptyStockWarehouseList[0].singletonWeight
        })
        .catch(err => {
          DonMessage.error(err)
        })
      // }
      getCusAvNuExp({
        primaryCustomerTaxId: this.huowuInfos.primaryCustomerTaxId,
        customerTaxId: this.huowuInfos.customerTaxId,
        productType: this.huowuInfos.productType,
        steelMillName: this.huowuInfos.steelMillName,
        model: this.huowuInfos.model,
        specification: this.huowuInfos.specification
      })
        .then(res => {
          console.log(res)
          // this.detailsDataCopyAdd[0].customerAvailableNumber = res
          this.$set(this.detailsDataCopyAdd[0], 'customerAvailableNumber', res)
        })
        .catch(error => {
          DonMessage.error(error.message)
        })

      // }
    },
    changeGuiGe(val, row) {
      console.log(val, row)
      // this.disChangDu = false
      this.disCaiZhi = false

      this.huowuInfos.specification = row
      this.huowuInfos.warehouseId = ''
      this.huowuInfos.stockWarehouseId = ''
      this.huowuInfos.model = ''
      this.detailsDataCopyAdd[0].model = ''
      this.detailsDataCopyAdd[0].warehouseId = ''
      this.detailsDataCopyAdd[0].locationId = ''
      this.detailsDataCopyAdd[0].stockAvailableNumber = ''
      this.detailsDataCopyAdd[0].allNumber = ''
      this.detailsDataCopyAdd[0].number = ''
      this.detailsDataCopyAdd[0].weight = ''
      getTEmptyStockCustomerGroupExp(
        this.huowuInfos
      )
        .then(res => {
          this.caizhiOptions = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(err => {
          DonMessage.error(err)
        })
    },
    changeQuWei( row,val) {
      this.disJianShu = false
      // this.huowuInfos.stockWarehouseId = val.stockWarehouseId
      let obj = this.QuweiOptions.find(o => o.id === val);
      console.log(row, 'row')
      console.log(obj, 'obj')
      this.$set(this.huowuInfos, 'stockWarehouseId', obj.stockWarehouseId)
      this.$set(this.detailsDataCopyAdd[0], 'stockWarehouseId', obj.stockWarehouseId)
      getTEmptyStockCustomerGroupExp(
        this.huowuInfos
      )
        .then(res => {
          this.root = res[0].root
          this.detailsDataCopyAdd[0].allNumber = res[0].allNumber
          // stockWarehouseId: item.stockWarehouseId,
          this.$set(this.detailsDataCopyAdd[0], 'stockCustomerId', res[0].stockCustomerId)

          // this.huowuInfos.stockCustomerId = res[0].stockCustomerId
        })
        .catch(err => {
          DonMessage.error(err)
        })
      // }
      if (row != '') {
        getNumberForBillStockWarehouse({
          ...this.huowuInfos
        })
          .then(res => {
            console.log(res)
            // this.detailsDataCopyAdd[0].stockAvailableNumber = res
            this.$set(this.detailsDataCopyAdd[0], 'stockAvailableNumber', res.whAvailableNumber)
          })
          .catch(err => {
            this.$message({
              message: err.message,
              type: 'error'
            })
          })
      }


    },
    changeCangWei(val, row) {
      let that = this
      console.log(val, row)
      that.disQuwei = false
      that.huowuInfos.warehouseId = row

      that.detailsDataCopyAdd[0].stockAvailableNumber = ''

      let choosenItem = that.CangweiOptions.filter(
        item => item.id === row
      )[0]
      that.huowuInfos.stockWarehouseId = choosenItem.stockWarehouseId
      console.log(that.huowuInfos, 'choosenItem')
      
      console.log(val, 'val')
      that.$set(val, 'locationId', '')

      getEmptyBillStockLocationInfo({
        ...that.huowuInfos
      })
        .then(res => {
          that.QuweiOptions = []

          if (res.length !== 0) {
            res.forEach((item, index) => {
              let arr = { value: item.locationName, id: item.locationId,stockWarehouseId:item.stockWarehouseId }
              that.QuweiOptions.push(arr)
            })
            that.QuweiOptions.forEach((item, index) => {
              if (item.id == null) {
                that.$set(item, 'value', '无')
              }
            })
          }
          console.log(that.QuweiOptions, 'that.QuweiOptions')

        })
        .catch(err => {
          that.$message({
            message: err.message,
            type: 'error'
          })
        })

    },
    changeJianShu(val, row) {
      console.log(val, row, this.singletonWeight)

      if (this.outWeighingMethod == 2) { // 磅重
        val.weight = (val.number / 1 * this.singletonWeight).toFixed(3)
        val.allWeight = (val.number / 1 * this.singletonWeight / 1).toFixed(3)
        val.weighingWeight = (val.number / 1 * this.singletonWeight / 1).toFixed(3)
        val.weighingDate = new Date().getTime()
        val.singletonWeight = this.singletonWeight
      } else {
        val.singletonWeight = this.singletonWeight
        val.weight = (val.number / 1 * this.singletonWeight).toFixed(3)
        val.allWeight = (val.number / 1 * this.singletonWeight / 1).toFixed(3)
      }
    },
    NumberInputWeight(val) {
      console.log(val)
      // val.weight = Number(val.weight).toFixed(3)
      // val.weight = (val.number / 1 * val.singletonWeight / 1).toFixed(3)

      val.allWeight = Number(val.allWeight).toFixed(3)
    },
    // 点击添加货物
    addProductTypeClick(row) {
      let that = this
      if (row.source == 5) {
        DonMessage.error('出库单来源为提单,不可进行操作!')
      } else {
        that.copyTableList = []
        if (row.productType == '5') {
          that.panLuo = false
        }
        var d = {
          steelMillName: '', // 产地
          model: '', // 材质
          specification: '', // 规格
          // length: '', // 长度（m）
          warehouseId: '', // 仓位
          warehouseName: '',
          locationId: '', // 区位
          locationName: '',
          allNumber: '', // 库存件数
          number: '', // 件数
          allWeight: '',
          weight: '', // 理重
          disWeight: true,
          stockAvailableNumber: ''
        }
        that.detailsDataCopyAdd.push(d)
      }
    },
    // 点击添加属性新增按钮
    addHuoWuBtn() {
      let that = this
      if (that.detailsDataCopyAdd.length >= 1) {
        that.copyEnd = that.detailsDataCopyAdd.slice(-1)
        if (that.copyEnd[0].steelMillName == '') {
          DonMessage.error('请先完善当前数据！')
        } else if (that.copyEnd[0].model == '') {
          DonMessage.error('请先完善当前数据！')
        } else if (that.copyEnd[0].specification == '') {
          DonMessage.error('请先完善当前数据！')
        } else if (that.copyEnd[0].warehouseId == '') {
          DonMessage.error('请先完善当前数据！')
        } else if (that.copyEnd[0].number == '') {
          DonMessage.error('请先完善当前数据！')
        } else if (that.copyEnd[0].weight == '') {
          DonMessage.error('请先完善当前数据！')
        } else {
          var d = {
            productType: '',
            steelMillName: '', // 产地
            model: '', // 材质
            specification: '', // 规格
            // singletonWeight: '', // 单间重量
            warehouseId: '', // 仓位
            locationId: '', // 区位
            // locationName: '',
            allNumber: '', // 库存件数
            warehouseName: '',
            number: '', // 件数
            weight: '', // 理重
            disWeight: true,
            stockAvailableNumber: ''

          }
          that.huowuInfos.steelMillName = ''
          that.huowuInfos.model = ''
          that.huowuInfos.specification = ''
          // that.huowuInfos.length = ''
          that.huowuInfos.warehouseId = ''
          that.huowuInfos.stockWarehouseId = ''

          that.CangweiOptions.forEach(item => {
            if (item.id == that.detailsDataCopyAdd[0].warehouseId) {
              that.detailsDataCopyAdd[0].warehouseName = item
                .value
            }
          })

          let hadAdd = false
          that.copyTableList.map((item, index) => {
            if (
              item.steelMillName == that.detailsDataCopyAdd[0].steelMillName &&
              item.model == that.detailsDataCopyAdd[0].model &&
              item.specification == that.detailsDataCopyAdd[0].specification &&
              item.warehouseId == that.detailsDataCopyAdd[0].warehouseId
            ) {
              hadAdd = true
            }
          })
          if (!hadAdd) {
            console.log(that.detailsDataCopyAdd[0])
            that.copyTableList.push(that.detailsDataCopyAdd[0])
            that.detailsDataCopyAdd.shift()

            that.detailsDataCopyAdd.push(d)
            that.disChandi = true
            that.disCaiZhi = true
            that.disCangwei = true
            that.disQuwei = true

            that.disGuige = true
            that.disJianShu = true

            // that.singletonWeight = 0
            that.Jhliang = (that.copyTableList.reduce((pre, cur) => {
              return pre / 1 + cur.weight / 1
            }, 0)).toFixed(3)
          } else {
            DonMessage.error('已有相同规格的货物')
          }
        }
      } else {
        that.disChandi = true
        that.disCangwei = true
        that.disQuwei = true
        that.disGuiGe = true
        // 材质选择框
        that.disCaiZhi = true
        // 规格选择框
        that.disGuige = true
        // 长度选择框
        // that.disChangDu = true
        // 件数
        that.disJianShu = true

        let d = {
          productType: '',
          steelMillName: '', // 产地
          model: '', // 材质
          specification: '', // 规格
          // length: '', // 长度（m）
          warehouseId: '', // 仓位
          allNumber: '', // 库存件数
          number: '', // 件数
          weight: '', // 理重
          allWeight: '',
          disWeight: true,
          stockAvailableNumber: ''

        }
        that.huowuInfos.steelMillName = ''
        that.huowuInfos.model = ''
        that.huowuInfos.specification = ''
        // that.huowuInfos.length = ''
        that.huowuInfos.warehouseId = ''
        that.huowuInfos.stockWarehouseId = ''

        that.detailsDataCopyAdd.push(d)
      }
    },
    // 点击添加属性删除-下表格
    delClick(index, row) {
      this.detailsDataCopyAdd.splice(index, 1)
    },
    // 点击添加属性删除----上表格
    delClickCopy(index, row) {
      this.copyTableList.splice(index, 1)
      this.Jhliang = Number(this.Jhliang / 1 - row.allWeight / 1).toFixed(3)
    },
    // 点击表格保存
    addOkClick(index, row) {
      console.log(row)
      let that = this
      that.CangweiOptions.forEach(item => {
        if (item.id == row.warehouseId) row.warehouseName = item.value
      })
      debugger
      that.QuweiOptions.forEach(item => {
        if (item.id == that.detailsDataCopyAdd[0].locationId) {
          that.detailsDataCopyAdd[0].locationName = item.value

        }
      })
      let hadAdd = false
      that.copyTableList.map((item, index) => {
        if (
          that.GuanlianHuowuRow.productType == '4' &&
          item.steelMillName == that.detailsDataCopyAdd[0].steelMillName &&
          item.model == that.detailsDataCopyAdd[0].model &&
          item.specification == that.detailsDataCopyAdd[0].specification &&
          item.warehouseId == that.detailsDataCopyAdd[0].warehouseId
        ) {
          hadAdd = true
        } else if (
          that.GuanlianHuowuRow.productType != '4' &&
          item.steelMillName == that.detailsDataCopyAdd[0].steelMillName &&
          item.model == that.detailsDataCopyAdd[0].model &&
          item.specification == that.detailsDataCopyAdd[0].specification &&
          item.warehouseId == that.detailsDataCopyAdd[0].warehouseId
        ) {
          hadAdd = true
        }
      })
      getWeighingMethodList({
        productType: this.detailsDataCopyAdd[0].productType
      }).then(res => {
        if (row.steelMillName == '') {
          DonMessage.error('请先完善当前数据！')
        } else if (row.pinMingValue == '') {
          DonMessage.error('请先完善当前数据！')
        } else if (row.caiZhiValue == '') {
          DonMessage.error('请先完善当前数据！')
        } else if (row.guiGeValue == '') {
          DonMessage.error('请先完善当前数据！')
        } else if (row.number == '') {
          DonMessage.error('请先完善当前数据！')
        } else if (row.warehouseId == '') {
          DonMessage.error('请先完善当前数据！')
        } else if (row.locationId == '') {
          DonMessage.error('请先完善当前数据！')
        } else if (row.number > row.stockAvailableNumber) {
          DonMessage.error('总件数不能大于此规格型号的库存可提件数')
        } else if (row.number == 0) {
          DonMessage.error('件数不能为0')
        } else if (hadAdd) {
          DonMessage.error('已有相同规格的货物')
        } else {
          this.copyTableList.push(this.detailsDataCopyAdd[0])
          this.detailsDataCopyAdd.shift()
        }
        this.Jhliang = this.copyTableList.reduce((pre, cur) => {
          return pre / 1 + cur.allWeight / 1
        }, 0).toFixed(3)
      }).catch(err => {
        this.$message({
          message: err.message,
          type: 'error'
        })
      })

      console.log(this.copyTableList, 'copyTableList')
      console.log(this.detailsDataCopyAdd, 'detailsDataCopyAdd')
    },
    // 添加属性确定
    additiveOk() {
      this.addSXList = []
      this.addOkNumber = 0
      if (this.copyTableList.length > 0) {
        console.log(this.copyTableList, 'copyTableList')

        this.copyTableList.forEach((item, index) => {
          if (item.steelMillName == '') {
            DonMessage.error('添加失败，产地不能为空')
            this.addOkNumber = 1
          } else if (item.model == '') {
            DonMessage.error('添加失败，材质不能为空')
            this.addOkNumber = 1
          } else if (item.specification == '') {
            DonMessage.error('添加失败，规格不能为空')
            this.addOkNumber = 1
          } else if (item.warehouseId == '') {
            DonMessage.error('添加失败，仓库不能为空')
            this.addOkNumber = 1
          } else if (item.warehouseName == '') {
            DonMessage.error('添加失败，仓库名称不能为空')
            this.addOkNumber = 1
          } else if (item.jianShuValue <= 0) {
            DonMessage.error('添加失败，件数必须大于零')
            this.addOkNumber = 1
          } else {
            // console.log(this.detailsDataCopyAdd, 'detailsDataCopyAdd')
            // let warehouseName
            // this.CangweiOptions.forEach(i => {
            //   if (i.id == item.warehouseId) {
            //     warehouseName = i.value
            //     console.log(warehouseName, 'warehouseName')
            //   }
            // })
            let productTypeName

            this.productTypeOptions.forEach(i => {
              if (i.id == item.productType) {
                productTypeName = i.name
              }
            })

            const obj = {
              outstockId: this.GuanlianHuowuRow.outstockId,
              stockWarehouseId: item.stockWarehouseId,
              stockCustomerId: item.stockCustomerId,
              placeOfOrigin: item.steelMillName,
              model: item.model,
              specification: item.specification,
              // length: item.length,
              warehouseId: item.warehouseId,
              warehouseName: item.warehouseName,
              locationId: item.locationId,
              locationName: item.locationName=='无'?'':item.locationName,
              weighingWeight: item.weighingWeight,
              weighingDate: item.weighingDate,
              // root: this.root,
              singletonWeight: this.singletonWeight,
              number: item.number,
              weight: item.weight,
              allWeight: item.allWeight,
              productName: productTypeName,
              productTypeName: productTypeName,
              productType: item.productType,
              customerAvailableNumber: item.customerAvailableNumber
            }
            this.addSXList.push(obj)
          }
        })
        if (this.addSXList.length == 0) {
          DonMessage.error('请填写需要添加的货物')
        } else if (this.addOkNumber == 1) { } else {
          if (this.jianShuValue > this.kuCunJianShuValue) {
            DonMessage.error('总件数不能大于此规格型号的库存件数')
          } else if (this.GuanlianHuowuRow.cargoControlFalg == 1 && Number(this.Jhliang) > Number(this.KhShengyu)) {
            console.log(this.Jhliang>this.KhShengyu,'this.Jhliang > this.KhShengyu111')

            DonMessage.error('计划量合计不能大于控货剩余量')
          } else {
            this.addSXList.forEach(item => {
              item.key = item.productTypeName + item.placeOfOrigin + item.model + item.specification
              // item.Num = 10
            })
            let arr = sortArr(this.addSXList, 'key')
            let infoArr = []
            arr.forEach(item => {
              let obj = {}
              // obj.allNumber = item.reduce((pre, cur) => pre / 1 + cur.number / 1, 0)
              obj.productType = item[0].productType
              obj.productTypeName = item[0].productTypeName
              obj.steelMillName = item[0].placeOfOrigin
              obj.model = item[0].model
              obj.specification = item[0].specification
              obj.primaryCustomerTaxId = this.primaryCustomerTaxId
              obj.customerTaxId = this.customerTaxId
              obj.number = item.reduce((pre, cur) => pre / 1 + cur.number / 1, 0)
              obj.customerAvailableNumber = item[0].customerAvailableNumber
              infoArr.push(obj)
            })
            for (let i = 0; i < infoArr.length; i++) {
              if (infoArr[i].number / 1 > infoArr[i].customerAvailableNumber) {
                console.log(infoArr[i])
                this.$message({
                  message: `【${infoArr[i].productTypeName}|${infoArr[i].steelMillName}|${infoArr[i].model}|${infoArr[i].specification}】总件数超过客户可提件数,请重新添加`,
                  type: 'error'
                })
                return
              }
            }
            const loading = this.$loading({
              lock: true,
              text: "正在处理",
            });
            this.listData = {
              outstockId: this.GuanlianHuowuRow.outstockId,
              list: this.addSXList,
              tStockSummaryList: infoArr
            }
            console.log(this.listData, 'this.listData')
            addTOutstockSummaryZy(this.listData)
              .then((res) => {
                // DonMessage.success('操作成功!')
                this.$message({
                  message: '操作成功!',
                  type: 'success'
                })
                loading.close();

                this.$emit('update:addProductTypeTwoMark', false)
                this.guanlianVisible = false
                // 刷新子表
                this.$parent.getOutstockSummaryLists()
                // this.getWhOutstockDetailListSummaryS() // 汇总数据
              })
              .catch((err) => {
                loading.close();

                this.$message({
                  message: err.message,
                  type: 'error'
                })
                console.log(err.message, 'err')
              })
          }
        }
      } else {
        DonMessage.error('请先添加要操作的数据!')
      }
    },
    additiveQuXiao() {
      this.guanlianVisible = false
      this.$emit('update:addProductTypeTwoMark', false)
    },
    getLwgTStockSummaryGroups() {
      getLwgTStockSummaryGroup(
        this.huowuInfos
      )
        .then(res => {
          console.log(res)
          console.log(res.map(item => item.steelMillName))
          // this.chanDiOptions = Array.from(new Set(res.map(item => item.steelMillName)))
          // this.caizhiOptions = Array.from(new Set(res.map(item => item.model)))
          // this.guigeOptions = Array.from(new Set(res.map(item => item.specification)))
          // this.changDuOptions = Array.from(new Set(res.map(item => item.length)))
          // let wareHouses = []
          // res.forEach(item => {
          //   let objVal = {}
          //   objVal.id = item.warehouseId
          //   objVal.value = item.warehouseName
          //   wareHouses.push(objVal)
          // })
          // if (this.huowuInfos.warehouseId == '') this.CangweiOptions = Array.from(new Set(wareHouses))
          // this.root = res[0].root
          // this.detailsDataCopyAdd[0].allNumber = res[0].allNumber
          // this.singletonWeight = res[0].singletonWeight
        })
        .catch(err => {
          DonMessage.error(err)
        })
    },
    getTEmptyStockCustomerGroupExps() {
      getTEmptyStockCustomerGroupExp(
        this.huowuInfos
      )
        .then(res => {
          console.log(res)
          let productArr = []
          res.forEach(item => {
            let obj = {}
            obj.id = item.productType
            obj.name = item.productTypeName
            productArr.push(obj)
          })
          const ress = new Map()
          let arrNew = productArr.filter((arr) => !ress.has(arr.id) && ress.set(arr.id, 1))
          this.productTypeOptions = arrNew

          // this.chanDiOptions = Array.from(new Set(res.map(item => item.steelMillName)))
          // this.caizhiOptions = Array.from(new Set(res.map(item => item.model)))
          // this.guigeOptions = Array.from(new Set(res.map(item => item.specification)))
          // this.changDuOptions = Array.from(new Set(res.map(item => item.length)))
          // let wareHouses = []
          // res.forEach(item => {
          //   let objVal = {}
          //   objVal.id = item.warehouseId
          //   objVal.value = item.warehouseName
          //   wareHouses.push(objVal)
          // })
          // if (this.huowuInfos.warehouseId == '') this.CangweiOptions = Array.from(new Set(wareHouses))
          // this.root = res[0].root
          // this.detailsDataCopyAdd[0].allNumber = res[0].allNumber
          // this.singletonWeight = res[0].singletonWeight
        })
        .catch(err => {
          DonMessage.error(err)
        })
    },
    surplusControlWeights() {
      surplusControlWeight({
        oneCustomerTaxId: this.GuanlianHuowuRow.primaryCustomerTaxId,
        twoCustomerTaxId: this.GuanlianHuowuRow.customerTaxId,
        organizationId: window.localStorage.getItem('tenantCode')
      })
        .then(res => {
          console.log(res)
          this.KhShengyu = Number(res).toFixed(3)
        })
    }
  }
}

</script>

<style lang='less' scoped>
.detailsTitles {
  display: flex;
  // justify-content: space-between;
  padding-right: 10px 10px;
  margin-left: 10px;
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 10px;

  h4 {
    margin: 0;
    font-size: 16px;
    color: #333;
    padding-bottom: 10px;
    border-bottom: 2px solid #0e6eec;
  }

  .printBox h4 {
    display: inline-block;
    margin-right: 20px;
  }

  .fa-reply {
    padding-right: 10px;
    color: #0e6eec;
  }
}

.redColor {
  color: red;
}
</style>
